import { EventAdapter } from '~analytics/adapters/EventAdapter';
import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';
import { EventTypes } from '~analytics/types';

interface UpdateRoomRosterEventParams {
  oldStudentCount: number;
  newStudentCount: number;
}

type UpdateRoomRosterEventData = {
  old_student_count: number;
  new_student_count: number;
};

export class UpdateRoomRosterEventAdapter extends EventAdapter<UpdateRoomRosterEventData> {
  protected intercomEventKey = null;
  protected amplitudeEventFunction = function sendEventData(
    eventData: UpdateRoomRosterEventData
  ) {
    sendTeacherAmplitudeEvent(EventTypes.UpdateRoomRoster, eventData);
  };

  constructor({
    newStudentCount,
    oldStudentCount,
  }: UpdateRoomRosterEventParams) {
    super();
    this.eventData = {
      old_student_count: oldStudentCount,
      new_student_count: newStudentCount,
    };
  }
}
